/* Sliding pagination area below the main product image on the product page. */
(function () {
  function initTheiauraMediaThumbPagination() {
    var mq = window.matchMedia && window.matchMedia("(max-width: 749px)");
    if (!mq || !mq.matches) return;

    var galleries = document.querySelectorAll('media-gallery[id^="MediaGallery-"]');
    if (!galleries || !galleries.length) return;

    galleries.forEach(function (gallery) {
      var progress = gallery.querySelector(".theiaura-media-progress");
      if (!progress) return;

      if (progress.dataset.taInit === "1") return;
      progress.dataset.taInit = "1";

      var track = progress.querySelector(".theiaura-media-progress__track");
      var thumb = progress.querySelector(".theiaura-media-progress__thumb");
      if (!track || !thumb) return;

      var scroller =
        gallery.querySelector('[id^="Slider-Gallery-"]') ||
        gallery.querySelector("ul.product__media-list.slider");
      if (!scroller) return;

      var slides = [];
      var total = 0;
      var thumbWidth = 0;

      var snapPoints = [];
      var firstSnap = 0;
      var lastSnap = 0;

      var raf = null;
      var stopTimer = null;

      function clamp(n, min, max) {
        return Math.max(min, Math.min(max, n));
      }

      function getLeftPad() {
        var cs = window.getComputedStyle(scroller);
        var sp = parseFloat(cs.scrollPaddingLeft || "0") || 0;
        var pl = parseFloat(cs.paddingLeft || "0") || 0;
        return sp || pl || 0;
      }

      function computeSnapPoints() {
        var leftPad = getLeftPad();
        return slides.map(function (slide) {
          var centerOffset = (scroller.clientWidth - slide.clientWidth) / 2;
          return slide.offsetLeft - leftPad - centerOffset;
        });
      }

      function setThumbByRatio(ratio) {
        ratio = clamp(ratio, 0, 1);
        thumb.style.left = ratio * (100 - thumbWidth) + "%";
      }

      function ratioFromScrollLeft(scrollLeft) {
        if (total <= 1) return 0;
        var denom = lastSnap - firstSnap;
        if (!denom) return 0;

        if (scrollLeft <= firstSnap + 0.5) return 0;
        if (scrollLeft >= lastSnap - 0.5) return 1;

        return clamp((scrollLeft - firstSnap) / denom, 0, 1);
      }

      function setThumbByScrollLeft(scrollLeft) {
        setThumbByRatio(ratioFromScrollLeft(scrollLeft));
      }

      function readSlides() {
        slides = Array.from(
          scroller.querySelectorAll("li.product__media-item.slider__slide")
        ).filter(function (el) {
          return el.clientWidth > 0;
        });

        total = slides.length;

        if (total <= 1) {
          progress.style.display = "none";
          return false;
        }

        progress.style.display = "";

        thumbWidth = 100 / total;
        thumb.style.width = thumbWidth + "%";

        snapPoints = computeSnapPoints();
        firstSnap = snapPoints[0];
        lastSnap = snapPoints[total - 1];

        setThumbByScrollLeft(scroller.scrollLeft);
        return true;
      }

      function updateContinuous() {
        raf = null;
        if (total <= 1) return;
        setThumbByScrollLeft(scroller.scrollLeft);
      }

      function requestUpdate() {
        if (raf) return;
        raf = requestAnimationFrame(updateContinuous);
      }

      function snapToNearestAfterStop() {
        if (total <= 1) return;

        var left = scroller.scrollLeft;
        var best = 0;
        var bestDist = Infinity;

        for (var i = 0; i < snapPoints.length; i++) {
          var d = Math.abs(left - snapPoints[i]);
          if (d < bestDist) {
            bestDist = d;
            best = i;
          }
        }

        setThumbByRatio(best / (total - 1));
      }

      function onScroll() {
        requestUpdate();
        clearTimeout(stopTimer);
        stopTimer = setTimeout(snapToNearestAfterStop, 160);
      }

      if (!readSlides()) return;

      scroller.addEventListener("scroll", onScroll, { passive: true });

      window.addEventListener("resize", function () {
        readSlides();
        requestUpdate();
        snapToNearestAfterStop();
      });

      setTimeout(function () {
        readSlides();
        requestUpdate();
        snapToNearestAfterStop();
      }, 250);
    });
  }

  if (!window.__TA_MEDIA_PROGRESS_BOOTSTRAPPED__) {
    window.__TA_MEDIA_PROGRESS_BOOTSTRAPPED__ = true;

    var run = function () {
      try {
        initTheiauraMediaThumbPagination();
      } catch (e) {}
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run, { once: true });
    } else {
      run();
    }

    document.addEventListener("shopify:section:load", run);
    document.addEventListener("shopify:section:reorder", run);
  } else {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initTheiauraMediaThumbPagination, { once: true });
    } else {
      initTheiauraMediaThumbPagination();
    }
  }
})();